import type {
  PropertySelectionRow,
  RequestedPicturesPlotDataResponse,
} from "../../types";

/**
 * RequestedPicturesPlotDataResponseをPropertySelectionRowに変換する
 * @param plot 変換元のRequestedPicturesPlotDataResponse
 * @param nextId 行ID
 * @param tags タグ配列
 * @returns PropertySelectionRow
 */
export const convertRequestedPicturesToPropertyRow = (
  plot: RequestedPicturesPlotDataResponse,
  nextId: number,
  tags: string[] = []
): PropertySelectionRow => {
  const rawData = {
    prefName: plot.prefectureName,
    cityName: "",
    ooazaName: null,
    azaName: null,
    chiban: plot.chiban,
    addressChiban: plot.chiban,
    polygon: undefined,
    lat: plot.latitude,
    lng: plot.longitude,
    address: plot.location,
    area: plot.area,
  };

  return {
    id: nextId,
    selected: true,
    bookType: "LAND" as const,
    prefName: plot.prefectureName,
    location: plot.location,
    chibanKaokuNumber: plot.chiban,
    area: plot.area,
    isFeedOrigin: false,
    rawData,
    tags,
    pinType: "requested-pictures",
  };
};
